<template>
  <div class="photo-uploader">
    <div
      class="photo-drop"
      :class="{ dragging: dragging, 'has-photo': photo, 'has-error': photoError }"
      @click="pickFile"
      @dragover.prevent="dragging = true"
      @dragleave="dragging = false"
      @drop.prevent="onDrop"
      @keydown="onKeydown"
      role="button"
      tabindex="0"
    >
      <template v-if="photo">
        <img :src="photo.url" alt="תמונת אומן" />
        <div class="photo-overlay">
          <LtIcon name="camera" :size="22" />
          <span>החלף תמונה</span>
        </div>
      </template>
      <div v-else class="photo-empty">
        <div class="photo-empty-icon"><LtIcon name="camera" :size="26" /></div>
        <div class="photo-empty-title">תמונת אומן</div>
        <div class="photo-empty-sub">גררו לכאן או לחצו להעלאה</div>
        <div class="photo-empty-hint">JPG · PNG · 600×600+</div>
      </div>
      <input ref="fileInput" type="file" accept=".jpg,.jpeg,.png,image/jpeg,image/png" @change="onFile" hidden />
    </div>
    <div v-if="photoError" class="field-error">
      <LtIcon name="info" :size="13" />{{ photoError }}
    </div>
    <button v-if="photo" type="button" class="photo-remove" @click.stop="clearPhoto">
      <LtIcon name="x" :size="14" />
      הסר תמונה
    </button>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';

const ALLOWED_EXT = ['jpg', 'jpeg', 'png'];
const ALLOWED_MIME = ['image/jpeg', 'image/png'];
const REJECT_MSG = 'ניתן להעלות רק קובץ JPG או PNG';

export default {
  name: 'PhotoUploader',
  components: { LtIcon },
  props: { photo: { type: Object, default: null } },
  emits: ['update:photo'],
  data() {
    return { dragging: false, photoError: '' };
  },
  methods: {
    pickFile() { this.$refs.fileInput.click(); },
    onFile(e) {
      const file = e.target.files && e.target.files[0];
      this.setFile(file);
    },
    onDrop(e) {
      this.dragging = false;
      const file = e.dataTransfer.files && e.dataTransfer.files[0];
      this.setFile(file);
    },
    setFile(file) {
      this.photoError = '';
      if (!file) return this.$emit('update:photo', null);

      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (!ALLOWED_EXT.includes(ext)) {
        return this.rejectFile();
      }
      if (file.type && !ALLOWED_MIME.includes(file.type)) {
        return this.rejectFile();
      }

      this.readSignature(file).then((valid) => {
        if (!valid) return this.rejectFile();
        const url = URL.createObjectURL(file);
        this.$emit('update:photo', { name: file.name, size: file.size, url, file });
      });
    },
    readSignature(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const bytes = new Uint8Array(e.target.result || []);
          resolve(this.isJpeg(bytes) || this.isPng(bytes));
        };
        reader.onerror = () => resolve(false);
        reader.readAsArrayBuffer(file.slice(0, 8));
      });
    },
    isJpeg(bytes) {
      return bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff;
    },
    isPng(bytes) {
      return bytes.length >= 8
        && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47
        && bytes[4] === 0x0d && bytes[5] === 0x0a && bytes[6] === 0x1a && bytes[7] === 0x0a;
    },
    rejectFile() {
      this.photoError = REJECT_MSG;
      this.resetInput();
    },
    resetInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    clearPhoto() {
      this.photoError = '';
      this.resetInput();
      this.$emit('update:photo', null);
    },
    onKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.pickFile();
      }
    },
  },
}
</script>
